var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show && _vm.lang,
          expression: "show && lang"
        }
      ],
      staticClass: "estates-carousel-similar"
    },
    [
      _c(
        "div",
        { staticClass: "p-0" },
        [
          _c("h2", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.lang.labels.similar_estates_title))
          ]),
          _vm._v(" "),
          _c("estates-carousel", {
            attrs: {
              estates: _vm.estates,
              "navigation-enabled": false,
              "per-page-custom": [
                [0, 1],
                [768, 2],
                [1440, 3]
              ]
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }